import { useState } from "react";
import { FormattedMessage as FM } from "react-intl";

import { STYLE_HOTEL_INPUT } from "../constants";

function ImageUrlField({ label, value, size, fallback, onChange }) {
  const [failedSrc, setFailedSrc] = useState(null);
  const src = value || fallback;
  const inherited = !value && Boolean(fallback);
  const failed = Boolean(src) && failedSrc === src;

  return (
    <div>
      <label className="block">
        <span className="mb-1 flex items-center gap-2 text-sm text-neutral-500">
          <FM id={label} />
          {inherited && (
            <span className="rounded bg-sky-50 px-1.5 py-0.5 text-[11px] font-medium text-sky-800">
              <FM id="melhous.dash.color.from_hotel" />
            </span>
          )}
        </span>
        <input
          type="url"
          inputMode="url"
          value={value}
          placeholder="https://"
          onChange={(event) => onChange(event.target.value)}
          className={STYLE_HOTEL_INPUT}
        />
      </label>
      <p className="mt-1 text-xs text-neutral-500">
        <FM id="melhous.dash.image.help" values={{ size }} />
      </p>
      {src && !failed && (
        <img
          src={src}
          alt=""
          onError={() => setFailedSrc(src)}
          className="mt-2 aspect-video w-full max-w-md rounded-md bg-neutral-100 object-cover"
        />
      )}
      {failed && (
        <p role="alert" className="mt-2 text-sm text-red-700">
          <FM id="melhous.dash.image.error" />
        </p>
      )}
    </div>
  );
}

export default ImageUrlField;
